import React, { useState } from 'react'
import { BodyRow } from './styles'
import InfoTooltip from './InfoTooltip'
import DataSizeDetails from './DataSizeDetails'
import moment from 'moment'
import globalNotification from 'live/services/global-notification'
import { Button } from 'react-bootstrap'

type OrphanRowProps = {
    orphan: Orphan
    fetchOrphans: (pageNumber: number, search: string) => void
}

const OrphanRow = ({ orphan, fetchOrphans }: OrphanRowProps): React.JSX.Element => {
    const [showDataSizeDetails, setShowDataSizeDetails] = useState(false)

    function formatBytes(bytes: number, decimals = 2): string {
        if (!+bytes) return '0 B'
        const k = 1024
        const dm = decimals < 0 ? 0 : decimals
        const sizes = ['B', 'KB', 'MB', 'GB', 'TB']
        const i = Math.floor(Math.log(bytes) / Math.log(k))

        return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
    }

    const handleDelete = async (): Promise<void> => {
        if (window.confirm('Are you sure you want to delete this item?')) {
            try {
                const response = await fetch(`/services/plugin-liverig/assets/well/${orphan.id}`, {
                    method: 'DELETE'
                })

                if (!response.ok) {
                    globalNotification.error(`Error while deleting wellbore ${orphan.name}`)
                } else {
                    globalNotification.success(`Wellbore ${orphan.name} was successfully deleted`)
                    fetchOrphans(1, '')
                }
            } catch (error) {
                console.error(`Error when deleting wellbore ${orphan.name}:`, error)
            }
        }
    }

    const calculateTotalDataSize = (): number => {
        let totalDataSize = 0
        if (orphan.normalizedDataStats) {
            totalDataSize += orphan.normalizedDataStats.dataSize
        }
        orphan.rawDataSizeStats.forEach(stats => {
            if (stats) {
                totalDataSize += stats.dataSize
            }
        })
        orphan.aggregationDataStats.forEach(stats => {
            if (stats) {
                totalDataSize += stats.dataSize
            }
        })

        return totalDataSize
    }

    return (
        <BodyRow key={orphan.id}>
            <InfoTooltip {...orphan}></InfoTooltip>
            <div className={'orphanWellboreName'}>{orphan.name}</div>
            <div>{orphan.edmXRef?.actualWellboreName}</div>
            <div>{orphan.normalizedEventType}</div>
            <div>
                <Button
                    variant="primary"
                    onClick={() => setShowDataSizeDetails(true)}
                    style={{ width: '100%', height: '100%' }}
                >
                    <i className={`fa fa-database`}></i> {formatBytes(calculateTotalDataSize() ?? 0)}
                </Button>
                {showDataSizeDetails ? (
                    <DataSizeDetails
                        normalizedDataStats={orphan.normalizedDataStats}
                        rawDataSizeStats={orphan.rawDataSizeStats}
                        aggregationDataStats={orphan.aggregationDataStats}
                        handleClose={() => setShowDataSizeDetails(false)}
                        show={showDataSizeDetails}
                    />
                ) : null}
            </div>
            <div onClick={() => window.open(`/#/wells/${orphan.id}`, '_blank')}>
                <i className={`fa fa-eye text-info`}></i>
            </div>
            {calculateTotalDataSize() > 0 ? (
                <div style={{ cursor: 'not-allowed' }}>
                    <i className={`fa fa-trash text-danger`}></i>
                </div>
            ) : (
                <div onClick={handleDelete} style={{ cursor: 'pointer' }}>
                    <i className={`fa fa-trash text-success`}></i>
                </div>
            )}
            <ul>
                <li>{orphan.edmXRef?.username}</li>
                <li>{moment(orphan.edmXRef?.lastUpdatedOn).format('YYYY-MM-DD')}</li>
            </ul>
        </BodyRow>
    )
}

export default OrphanRow
